package com.evoapps.evoshift.ui.util

import com.evoapps.evoshift.ui.user.toUiText as requestText

import evoshift.composeapp.generated.resources.clock_unplanned_extra_done
import evoshift.composeapp.generated.resources.saves_in_progress
import evoshift.composeapp.generated.resources.split_problem_nobody
import evoshift.composeapp.generated.resources.split_problem_already
import evoshift.composeapp.generated.resources.split_problem_outside
import evoshift.composeapp.generated.resources.split_problem_same_person
import evoshift.composeapp.generated.resources.split_problem_closed
import evoshift.composeapp.generated.resources.split_problem_missing
import evoshift.composeapp.generated.resources.error_request_limit
import evoshift.composeapp.generated.resources.request_not_offered
import evoshift.composeapp.generated.resources.error_access_revoked
import evoshift.composeapp.generated.resources.availability_link_invalid_days
import evoshift.composeapp.generated.resources.availability_link_invalid_title
import evoshift.composeapp.generated.resources.availability_link_locked
import evoshift.composeapp.generated.resources.availability_link_rate_limited
import evoshift.composeapp.generated.resources.availability_link_read_only
import evoshift.composeapp.generated.resources.clock_unplanned_cover_done
import evoshift.composeapp.generated.resources.clock_review_error_plan_ended
import evoshift.composeapp.generated.resources.work_hours_error_already_confirmed
import evoshift.composeapp.generated.resources.work_hours_error_in_future
import evoshift.composeapp.generated.resources.work_hours_error_not_worked
import evoshift.composeapp.generated.resources.work_hours_error_not_yours
import evoshift.composeapp.generated.resources.work_hours_error_outside_window
import evoshift.composeapp.generated.resources.work_hours_error_self_entry_off
import evoshift.composeapp.generated.resources.clock_review_edit_invalid
import evoshift.composeapp.generated.resources.clock_review_error_no_plan
import evoshift.composeapp.generated.resources.clock_review_error_not_clocked
import evoshift.composeapp.generated.resources.clock_review_error_decided
import evoshift.composeapp.generated.resources.clock_already_done
import evoshift.composeapp.generated.resources.clock_undo_too_late
import evoshift.composeapp.generated.resources.clock_no_shift_now
import evoshift.composeapp.generated.resources.date_format_invalid
import evoshift.composeapp.generated.resources.job_error_too_long
import evoshift.composeapp.generated.resources.interview_error_participants
import evoshift.composeapp.generated.resources.interview_error_link
import evoshift.composeapp.generated.resources.interview_error_place
import evoshift.composeapp.generated.resources.interview_error_length
import evoshift.composeapp.generated.resources.interview_error_time
import evoshift.composeapp.generated.resources.job_error_cv_types
import evoshift.composeapp.generated.resources.job_error_contact
import evoshift.composeapp.generated.resources.job_error_employer
import evoshift.composeapp.generated.resources.job_error_pay_range
import evoshift.composeapp.generated.resources.job_error_pay
import evoshift.composeapp.generated.resources.job_error_title
import evoshift.composeapp.generated.resources.shift_note_nobody
import evoshift.composeapp.generated.resources.shared_cost_error_percentages
import evoshift.composeapp.generated.resources.shared_cost_error_amounts
import evoshift.composeapp.generated.resources.shared_cost_error_workplaces
import evoshift.composeapp.generated.resources.shared_cost_error_negative
import evoshift.composeapp.generated.resources.shared_cost_error_basis
import evoshift.composeapp.generated.resources.shared_cost_error_end
import evoshift.composeapp.generated.resources.workplace_groups_error_name
import evoshift.composeapp.generated.resources.workplace_groups_error_name_long
import evoshift.composeapp.generated.resources.workplace_groups_error_not_owned
import evoshift.composeapp.generated.resources.group_managers_error_malformed
import evoshift.composeapp.generated.resources.access_error_not_allowed
import evoshift.composeapp.generated.resources.access_blocked_self
import evoshift.composeapp.generated.resources.access_error_above_own
import evoshift.composeapp.generated.resources.access_blocked_owner
import evoshift.composeapp.generated.resources.access_blocked_group
import evoshift.composeapp.generated.resources.access_error_plan
import evoshift.composeapp.generated.resources.access_error_name_taken
import evoshift.composeapp.generated.resources.access_error_too_many_roles
import evoshift.composeapp.generated.resources.access_error_role_in_use
import evoshift.composeapp.generated.resources.access_error_not_found
import evoshift.composeapp.generated.resources.roles_name_error
import evoshift.composeapp.generated.resources.group_managers_error_not_in_business
import evoshift.composeapp.generated.resources.group_managers_error_not_signed_up
import evoshift.composeapp.generated.resources.group_managers_error_not_your_group
import evoshift.composeapp.generated.resources.group_managers_error_owner
import evoshift.composeapp.generated.resources.group_managers_error_too_many_workplaces
import evoshift.composeapp.generated.resources.workplace_groups_error_too_many
import evoshift.composeapp.generated.resources.workplace_groups_error_two_groups
import evoshift.composeapp.generated.resources.shared_cost_error_not_owned
import evoshift.composeapp.generated.resources.announcement_too_long
import evoshift.composeapp.generated.resources.accountant_mail_too_soon
import evoshift.composeapp.generated.resources.accountant_mail_not_set_up
import evoshift.composeapp.generated.resources.break_problem_ends_before_start
import evoshift.composeapp.generated.resources.break_problem_open
import evoshift.composeapp.generated.resources.break_problem_outside_shift
import evoshift.composeapp.generated.resources.break_problem_overlap
import evoshift.composeapp.generated.resources.break_problem_too_many
import evoshift.composeapp.generated.resources.break_problem_unreadable
import evoshift.composeapp.generated.resources.clock_already_on_break
import evoshift.composeapp.generated.resources.clock_not_on_break
import evoshift.composeapp.generated.resources.clock_too_many_breaks
import evoshift.composeapp.generated.resources.error_sign_in_not_set_up_desktop
import com.evoapps.evoshift.domain.usecase.auth.OwnsWorkplacesException
import com.evoapps.evoshift.domain.usecase.auth.SignInMethodDisabledException
import com.evoapps.evoshift.observability.AppTelemetry
import evoshift.composeapp.generated.resources.profile_photo_refused
import evoshift.composeapp.generated.resources.checklist_problem_no_name
import evoshift.composeapp.generated.resources.checklist_problem_no_items
import evoshift.composeapp.generated.resources.checklist_problem_empty_item
import evoshift.composeapp.generated.resources.checklist_problem_too_many
import evoshift.composeapp.generated.resources.checklist_problem_too_long
import evoshift.composeapp.generated.resources.checklist_problem_not_attached
import evoshift.composeapp.generated.resources.checklist_note_required
import evoshift.composeapp.generated.resources.documents_file_empty
import evoshift.composeapp.generated.resources.documents_file_too_large
import evoshift.composeapp.generated.resources.documents_file_unsupported
import evoshift.composeapp.generated.resources.documents_refused
import evoshift.composeapp.generated.resources.documents_transfer_failed
import evoshift.composeapp.generated.resources.profile_photo_too_large
import evoshift.composeapp.generated.resources.profile_photo_upload_failed
import evoshift.composeapp.generated.resources.delete_account_owns_workplaces
import evoshift.composeapp.generated.resources.error_sign_in_method_disabled
import evoshift.composeapp.generated.resources.error_not_a_one_off_cost
import evoshift.composeapp.generated.resources.adjustment_month_locked
import evoshift.composeapp.generated.resources.email_roster_not_published
import evoshift.composeapp.generated.resources.email_roster_not_set_up
import evoshift.composeapp.generated.resources.email_roster_plan_ended
import evoshift.composeapp.generated.resources.email_roster_too_soon
import evoshift.composeapp.generated.resources.error_one_off_amount
import evoshift.composeapp.generated.resources.error_one_off_date
import evoshift.composeapp.generated.resources.error_one_off_period
import evoshift.composeapp.generated.resources.field_required
import evoshift.composeapp.generated.resources.error_absence_reason_too_long
import evoshift.composeapp.generated.resources.leave_allowance_invalid
import evoshift.composeapp.generated.resources.tips_amount_invalid
import evoshift.composeapp.generated.resources.tips_period_invalid
import evoshift.composeapp.generated.resources.tips_weight_invalid
import evoshift.composeapp.generated.resources.export_limit_reached
import evoshift.composeapp.generated.resources.export_sign_in_again_text
import com.evoapps.evoshift.domain.usecase.NoPayRatesException
import com.evoapps.evoshift.domain.billing.BillingException
import evoshift.composeapp.generated.resources.error_billing_not_allowed
import evoshift.composeapp.generated.resources.error_billing_not_configured
import evoshift.composeapp.generated.resources.error_billing_offer_unavailable
import evoshift.composeapp.generated.resources.error_billing_pending
import evoshift.composeapp.generated.resources.error_billing_store
import evoshift.composeapp.generated.resources.error_no_pay_rates
import evoshift.composeapp.generated.resources.daily_records_locked
import evoshift.composeapp.generated.resources.sales_import_file_empty
import evoshift.composeapp.generated.resources.spreadsheet_problem_empty
import evoshift.composeapp.generated.resources.spreadsheet_problem_too_large
import evoshift.composeapp.generated.resources.spreadsheet_problem_too_large_unpacked
import evoshift.composeapp.generated.resources.spreadsheet_problem_legacy_xls
import evoshift.composeapp.generated.resources.spreadsheet_problem_password
import evoshift.composeapp.generated.resources.spreadsheet_problem_not_spreadsheet
import evoshift.composeapp.generated.resources.spreadsheet_problem_corrupt
import evoshift.composeapp.generated.resources.sales_import_file_unreadable
import evoshift.composeapp.generated.resources.sales_import_file_too_large
import evoshift.composeapp.generated.resources.sales_import_file_no_sales
import evoshift.composeapp.generated.resources.pos_error_key_invalid
import evoshift.composeapp.generated.resources.pos_error_key_rejected
import evoshift.composeapp.generated.resources.pos_error_no_merchant
import evoshift.composeapp.generated.resources.pos_error_vat_invalid
import evoshift.composeapp.generated.resources.pos_error_not_connected
import evoshift.composeapp.generated.resources.kiosk_error_plan_ended
import evoshift.composeapp.generated.resources.clock_not_in
import evoshift.composeapp.generated.resources.clock_already_in
import evoshift.composeapp.generated.resources.clock_not_yours
import evoshift.composeapp.generated.resources.clock_too_early
import com.evoapps.evoshift.domain.usecase.shift.ClockException
import com.evoapps.evoshift.domain.model.ClockOutcome
import com.evoapps.evoshift.domain.model.GeofenceSettings
import com.evoapps.evoshift.domain.model.LocationCheck
import com.evoapps.evoshift.domain.model.LocationUnavailable
import evoshift.composeapp.generated.resources.clock_outside_area
import evoshift.composeapp.generated.resources.clock_location_denied
import evoshift.composeapp.generated.resources.clock_location_no_fix
import evoshift.composeapp.generated.resources.clock_location_unsupported
import evoshift.composeapp.generated.resources.clock_flag_outside
import evoshift.composeapp.generated.resources.clock_flag_unverified
import evoshift.composeapp.generated.resources.claim_refused_overlap
import evoshift.composeapp.generated.resources.claim_refused_own
import evoshift.composeapp.generated.resources.claim_refused_not_available
import com.evoapps.evoshift.domain.model.ClaimRefusedException
import com.evoapps.evoshift.domain.model.ClaimRefusal
import com.evoapps.evoshift.domain.model.NotFoundException
import evoshift.composeapp.generated.resources.error_invalid_email
import dev.gitlive.firebase.auth.FirebaseAuthException
import dev.gitlive.firebase.auth.FirebaseAuthEmailException
import androidx.compose.runtime.Composable
import com.evoapps.evoshift.data.remote.CloudFunctionsException
import com.evoapps.evoshift.domain.usecase.CreateRosterUseCase
import dev.gitlive.firebase.FirebaseNetworkException
import dev.gitlive.firebase.FirebaseTooManyRequestsException
import dev.gitlive.firebase.auth.FirebaseAuthInvalidCredentialsException
import dev.gitlive.firebase.auth.FirebaseAuthInvalidUserException
import dev.gitlive.firebase.auth.FirebaseAuthRecentLoginRequiredException
import dev.gitlive.firebase.auth.FirebaseAuthUserCollisionException
import dev.gitlive.firebase.auth.FirebaseAuthWeakPasswordException
import dev.gitlive.firebase.firestore.FirebaseFirestoreException
import dev.gitlive.firebase.firestore.FirestoreExceptionCode
import dev.gitlive.firebase.firestore.code
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.settings_labour_budget_invalid
import evoshift.composeapp.generated.resources.error_email_in_use
import evoshift.composeapp.generated.resources.error_generic
import evoshift.composeapp.generated.resources.error_generic_detail
import evoshift.composeapp.generated.resources.error_invalid_credentials
import evoshift.composeapp.generated.resources.error_not_found
import evoshift.composeapp.generated.resources.error_offline
import evoshift.composeapp.generated.resources.paywall_change_in_portal
import evoshift.composeapp.generated.resources.error_permission_denied
import evoshift.composeapp.generated.resources.group_settings_error_footer
import evoshift.composeapp.generated.resources.group_settings_error_invalid
import evoshift.composeapp.generated.resources.group_settings_error_no_group
import evoshift.composeapp.generated.resources.group_settings_error_not_finances
import evoshift.composeapp.generated.resources.group_settings_error_plan_ended
import evoshift.composeapp.generated.resources.error_recent_login
import evoshift.composeapp.generated.resources.error_roster_exists
import evoshift.composeapp.generated.resources.error_availability_month_passed
import evoshift.composeapp.generated.resources.error_availability_month_closed
import evoshift.composeapp.generated.resources.error_session_expired
import evoshift.composeapp.generated.resources.error_too_many_requests
import evoshift.composeapp.generated.resources.error_weak_password
import evoshift.composeapp.generated.resources.course_answer_all
import evoshift.composeapp.generated.resources.course_failure_changed
import evoshift.composeapp.generated.resources.course_failure_confirmation
import evoshift.composeapp.generated.resources.course_failure_no_attempts
import evoshift.composeapp.generated.resources.course_failure_not_ready
import evoshift.composeapp.generated.resources.course_failure_nothing_to_confirm
import evoshift.composeapp.generated.resources.course_failure_plan_ended
import evoshift.composeapp.generated.resources.course_failure_owner
import evoshift.composeapp.generated.resources.course_failure_self_study
import evoshift.composeapp.generated.resources.course_failure_test_not_passed
import evoshift.composeapp.generated.resources.course_problem_due_days
import evoshift.composeapp.generated.resources.course_problem_image
import evoshift.composeapp.generated.resources.course_problem_presentation
import evoshift.composeapp.generated.resources.course_problem_course_too_large
import evoshift.composeapp.generated.resources.course_problem_no_pages
import evoshift.composeapp.generated.resources.course_problem_ohs_hours
import evoshift.composeapp.generated.resources.course_problem_ohs_instructor
import evoshift.composeapp.generated.resources.course_problem_ohs_quiz
import evoshift.composeapp.generated.resources.course_problem_options
import evoshift.composeapp.generated.resources.course_problem_pass_percent
import evoshift.composeapp.generated.resources.course_problem_question_text
import evoshift.composeapp.generated.resources.course_problem_right_answer
import evoshift.composeapp.generated.resources.course_problem_title
import evoshift.composeapp.generated.resources.course_problem_too_long
import evoshift.composeapp.generated.resources.course_problem_too_many_pages
import evoshift.composeapp.generated.resources.course_problem_too_many_questions
import evoshift.composeapp.generated.resources.course_problem_video_link
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

/**
 * A message for the user that view models can hold without knowing the UI language.
 * Screens turn it into text with [asString]; arguments may themselves be [UiText].
 */
sealed interface UiText {
    /** Text that is already user-facing (e.g. typed by a person or sent by the server). */
    data class Raw(val value: String) : UiText

    data class Resource(val id: StringResource, val args: List<Any> = emptyList()) : UiText {
        constructor(id: StringResource, vararg args: Any) : this(id, args.toList())
    }
}

@Composable
fun UiText.asString(): String = when (this) {
    is UiText.Raw -> value
    is UiText.Resource -> {
        val resolved = args.map { if (it is UiText) it.asString() else it }
        stringResource(id, *resolved.toTypedArray())
    }
}

/**
 * A friendly, localised message for a failure. Known Firebase / domain failures get their own
 * text; anything else shows a generic message with the technical detail for support.
 */
fun Throwable.toUiText(): UiText = when (this) {
    is NotFoundException -> UiText.Resource(Res.string.error_not_found)
    // SH-188: a live read refused under the rules: the person no longer works there.
    is com.evoapps.evoshift.domain.util.WorkplaceAccessRevokedException -> UiText.Resource(Res.string.error_access_revoked)
    // SH-173: the web form behind an e-mailed availability link.
    is com.evoapps.evoshift.domain.model.AvailabilityLinkException -> UiText.Resource(
        when (reason) {
            com.evoapps.evoshift.domain.model.AvailabilityLinkException.Reason.INVALID -> Res.string.availability_link_invalid_title
            com.evoapps.evoshift.domain.model.AvailabilityLinkException.Reason.RATE_LIMITED -> Res.string.availability_link_rate_limited
            com.evoapps.evoshift.domain.model.AvailabilityLinkException.Reason.LOCKED -> Res.string.availability_link_locked
            com.evoapps.evoshift.domain.model.AvailabilityLinkException.Reason.READ_ONLY -> Res.string.availability_link_read_only
            com.evoapps.evoshift.domain.model.AvailabilityLinkException.Reason.INVALID_DAYS -> Res.string.availability_link_invalid_days
        }
    )
    // SH-148: a second submit while the first save still runs.
    is com.evoapps.evoshift.saves.SaveInProgressException -> UiText.Resource(Res.string.saves_in_progress)
    is com.evoapps.evoshift.domain.model.KioskException -> kioskText()
    is com.evoapps.evoshift.domain.model.KioskOfflineException -> UiText.Resource(Res.string.error_offline)
    is OwnsWorkplacesException -> UiText.Resource(Res.string.delete_account_owns_workplaces)
    is SignInMethodDisabledException -> UiText.Resource(Res.string.error_sign_in_method_disabled)
    is com.evoapps.evoshift.domain.usecase.auth.SignInNotAvailableHereException -> UiText.Resource(Res.string.error_sign_in_not_set_up_desktop)
    is com.evoapps.evoshift.domain.usecase.auth.AccountExistsWithOtherSignInException -> UiText.Resource(Res.string.error_email_in_use)
    is com.evoapps.evoshift.domain.model.AbsenceReasonTooLongException -> UiText.Resource(Res.string.error_absence_reason_too_long, maxLength)
    // SH-223: a request over its limit, or a work request with something missing.
    is com.evoapps.evoshift.domain.usecase.RequestLimitException -> check.requestText() ?: UiText.Resource(Res.string.error_request_limit)
    is com.evoapps.evoshift.domain.usecase.requests.InvalidWorkRequestException -> requestText()
    is com.evoapps.evoshift.domain.requests.RequestNotAllowedException -> UiText.Resource(Res.string.request_not_offered)
    is com.evoapps.evoshift.domain.model.InvalidLeaveAllowanceException ->
        UiText.Resource(Res.string.leave_allowance_invalid, com.evoapps.evoshift.domain.model.LeaveAllowance.MAX_DAYS)
    is com.evoapps.evoshift.domain.model.TipException -> UiText.Resource(
        when (reason) {
            com.evoapps.evoshift.domain.model.TipException.Reason.INVALID_AMOUNT -> Res.string.tips_amount_invalid
            com.evoapps.evoshift.domain.model.TipException.Reason.INVALID_PERIOD -> Res.string.tips_period_invalid
            com.evoapps.evoshift.domain.model.TipException.Reason.INVALID_WEIGHT -> Res.string.tips_weight_invalid
            com.evoapps.evoshift.domain.model.TipException.Reason.UNKNOWN -> Res.string.tips_amount_invalid
        },
        if (reason == com.evoapps.evoshift.domain.model.TipException.Reason.INVALID_WEIGHT) listOf<Any>(com.evoapps.evoshift.domain.model.TipSplit.MAX_WEIGHT) else emptyList()
    )
    is com.evoapps.evoshift.domain.model.ExportLimitReachedException -> UiText.Resource(Res.string.export_limit_reached)
    is com.evoapps.evoshift.domain.model.RecentSignInRequiredException -> UiText.Resource(Res.string.export_sign_in_again_text)
    // SH-117: the accountant export by e-mail.
    is com.evoapps.evoshift.domain.model.AccountantMailLimitException -> UiText.Resource(Res.string.accountant_mail_too_soon)
    is com.evoapps.evoshift.domain.model.AccountantMailUnavailableException -> UiText.Resource(Res.string.accountant_mail_not_set_up)
    is com.evoapps.evoshift.domain.model.InvalidEmailException -> UiText.Resource(Res.string.error_invalid_email)
    is NoPayRatesException -> UiText.Resource(Res.string.error_no_pay_rates)
    is com.evoapps.evoshift.domain.budget.InvalidLabourBudgetException -> UiText.Resource(Res.string.settings_labour_budget_invalid)
    is com.evoapps.evoshift.domain.model.DayClosedException -> UiText.Resource(Res.string.daily_records_locked)
    // SH-236: splitting a shift and undoing a split.
    is com.evoapps.evoshift.domain.model.ShiftSplitException -> UiText.Resource(problem.textRes())
    // SH-123: sales files and the till.
    is com.evoapps.evoshift.domain.salesimport.SalesFileException -> when (problem) {
        com.evoapps.evoshift.domain.salesimport.SalesFileProblem.EMPTY -> UiText.Resource(Res.string.sales_import_file_empty)
        com.evoapps.evoshift.domain.salesimport.SalesFileProblem.UNREADABLE -> UiText.Resource(Res.string.sales_import_file_unreadable)
        com.evoapps.evoshift.domain.salesimport.SalesFileProblem.TOO_LARGE -> UiText.Resource(
            Res.string.sales_import_file_too_large,
            com.evoapps.evoshift.domain.salesimport.SalesSheetParser.MAX_ROWS,
            com.evoapps.evoshift.domain.salesimport.SalesSheetParser.MAX_BYTES / (1024 * 1024)
        )
        com.evoapps.evoshift.domain.salesimport.SalesFileProblem.NO_SALES -> UiText.Resource(Res.string.sales_import_file_no_sales)
    }
    // SH-214: a spreadsheet that cannot be read (staff import; SH-217 roster import).
    is com.evoapps.evoshift.domain.spreadsheet.SpreadsheetException -> when (problem) {
        com.evoapps.evoshift.domain.spreadsheet.SpreadsheetProblem.EMPTY -> UiText.Resource(Res.string.spreadsheet_problem_empty)
        com.evoapps.evoshift.domain.spreadsheet.SpreadsheetProblem.TOO_LARGE -> UiText.Resource(
            Res.string.spreadsheet_problem_too_large,
            com.evoapps.evoshift.domain.spreadsheet.SpreadsheetReader.MAX_FILE_BYTES / (1024 * 1024),
            com.evoapps.evoshift.domain.spreadsheet.SpreadsheetReader.MAX_ROWS
        )
        com.evoapps.evoshift.domain.spreadsheet.SpreadsheetProblem.TOO_LARGE_UNPACKED -> UiText.Resource(Res.string.spreadsheet_problem_too_large_unpacked)
        com.evoapps.evoshift.domain.spreadsheet.SpreadsheetProblem.LEGACY_XLS -> UiText.Resource(Res.string.spreadsheet_problem_legacy_xls)
        com.evoapps.evoshift.domain.spreadsheet.SpreadsheetProblem.PASSWORD_PROTECTED -> UiText.Resource(Res.string.spreadsheet_problem_password)
        com.evoapps.evoshift.domain.spreadsheet.SpreadsheetProblem.NOT_A_SPREADSHEET -> UiText.Resource(Res.string.spreadsheet_problem_not_spreadsheet)
        com.evoapps.evoshift.domain.spreadsheet.SpreadsheetProblem.CORRUPT -> UiText.Resource(Res.string.spreadsheet_problem_corrupt)
    }
    is com.evoapps.evoshift.domain.usecase.finance.SalesImportNotAllowedException -> UiText.Resource(Res.string.error_permission_denied)
    is com.evoapps.evoshift.domain.model.PosConnectionException -> UiText.Resource(
        when (reason) {
            com.evoapps.evoshift.domain.model.PosRefusal.KEY_INVALID -> Res.string.pos_error_key_invalid
            com.evoapps.evoshift.domain.model.PosRefusal.KEY_REJECTED -> Res.string.pos_error_key_rejected
            com.evoapps.evoshift.domain.model.PosRefusal.NO_MERCHANT -> Res.string.pos_error_no_merchant
            com.evoapps.evoshift.domain.model.PosRefusal.VAT_INVALID -> Res.string.pos_error_vat_invalid
            com.evoapps.evoshift.domain.model.PosRefusal.NOT_CONNECTED -> Res.string.pos_error_not_connected
            com.evoapps.evoshift.domain.model.PosRefusal.PLAN_ENDED -> Res.string.kiosk_error_plan_ended
        }
    )
    is com.evoapps.evoshift.domain.model.InvalidOneOffCostException -> UiText.Resource(
        when (problem) {
            com.evoapps.evoshift.domain.model.InvalidOneOffCostException.Problem.NAME_MISSING -> Res.string.field_required
            com.evoapps.evoshift.domain.model.InvalidOneOffCostException.Problem.AMOUNT_NOT_POSITIVE -> Res.string.error_one_off_amount
            com.evoapps.evoshift.domain.model.InvalidOneOffCostException.Problem.DATE_OUTSIDE_MONTH -> Res.string.error_one_off_date
            com.evoapps.evoshift.domain.model.InvalidOneOffCostException.Problem.PERIOD_ENDS_BEFORE_START -> Res.string.error_one_off_period
        }
    )
    // SH-131: the first thing wrong with a shared cost (the editor marks the fields as well).
    is com.evoapps.evoshift.domain.model.InvalidSharedCostException -> UiText.Resource(
        when (problems.firstOrNull()) {
            com.evoapps.evoshift.domain.model.SharedCostAllocation.Problem.AMOUNT_NOT_POSITIVE -> Res.string.error_one_off_amount
            com.evoapps.evoshift.domain.model.SharedCostAllocation.Problem.PERCENTAGES_NOT_100 -> Res.string.shared_cost_error_percentages
            com.evoapps.evoshift.domain.model.SharedCostAllocation.Problem.AMOUNTS_NOT_TOTAL -> Res.string.shared_cost_error_amounts
            com.evoapps.evoshift.domain.model.SharedCostAllocation.Problem.NO_WORKPLACES -> Res.string.shared_cost_error_workplaces
            com.evoapps.evoshift.domain.model.SharedCostAllocation.Problem.NEGATIVE_SHARE -> Res.string.shared_cost_error_negative
            com.evoapps.evoshift.domain.model.SharedCostAllocation.Problem.BASIS_MISSING -> Res.string.shared_cost_error_basis
            com.evoapps.evoshift.domain.model.SharedCostAllocation.Problem.END_BEFORE_START -> Res.string.shared_cost_error_end
            else -> Res.string.field_required
        }
    )
    // SH-267: the first thing wrong with the owner's workplace groups.
    is com.evoapps.evoshift.domain.model.InvalidWorkplaceGroupsException -> UiText.Resource(
        when (problems.firstOrNull()) {
            com.evoapps.evoshift.domain.model.WorkplaceGroups.Problem.NAME_TOO_LONG -> Res.string.workplace_groups_error_name_long
            com.evoapps.evoshift.domain.model.WorkplaceGroups.Problem.WORKPLACE_IN_TWO_GROUPS -> Res.string.workplace_groups_error_two_groups
            com.evoapps.evoshift.domain.model.WorkplaceGroups.Problem.TOO_MANY -> Res.string.workplace_groups_error_too_many
            com.evoapps.evoshift.domain.model.WorkplaceGroups.Problem.WORKPLACE_NOT_OWNED -> Res.string.workplace_groups_error_not_owned
            else -> Res.string.workplace_groups_error_name
        }
    )
    is com.evoapps.evoshift.domain.model.InvalidGroupManagersException -> UiText.Resource(
        when (problem) {
            com.evoapps.evoshift.domain.model.GroupManagers.Problem.MALFORMED -> Res.string.group_managers_error_malformed
            com.evoapps.evoshift.domain.model.GroupManagers.Problem.OWNER_IS_NOT_A_MANAGER -> Res.string.group_managers_error_owner
            com.evoapps.evoshift.domain.model.GroupManagers.Problem.NOT_IN_BUSINESS -> Res.string.group_managers_error_not_in_business
            com.evoapps.evoshift.domain.model.GroupManagers.Problem.NOT_SIGNED_UP -> Res.string.group_managers_error_not_signed_up
            com.evoapps.evoshift.domain.model.GroupManagers.Problem.TOO_MANY_WORKPLACES -> Res.string.group_managers_error_too_many_workplaces
            com.evoapps.evoshift.domain.model.GroupManagers.Problem.NOT_YOUR_GROUP -> Res.string.group_managers_error_not_your_group
        }
    )
    // SH-270: a role or an access change the server refused.
    is com.evoapps.evoshift.domain.model.AccessRefusedException -> UiText.Resource(
        when (problem) {
            com.evoapps.evoshift.domain.model.AccessProblem.NOT_ALLOWED,
            com.evoapps.evoshift.domain.model.AccessProblem.NOT_AN_OWNER -> Res.string.access_error_not_allowed
            com.evoapps.evoshift.domain.model.AccessProblem.OWN_ACCESS -> Res.string.access_blocked_self
            com.evoapps.evoshift.domain.model.AccessProblem.ABOVE_OWN -> Res.string.access_error_above_own
            com.evoapps.evoshift.domain.model.AccessProblem.OWNER_ACCESS,
            com.evoapps.evoshift.domain.model.AccessProblem.OWNER_ROLE -> Res.string.access_blocked_owner
            com.evoapps.evoshift.domain.model.AccessProblem.GROUP_GRANT -> Res.string.access_blocked_group
            com.evoapps.evoshift.domain.model.AccessProblem.PLAN_ENDED -> Res.string.access_error_plan
            com.evoapps.evoshift.domain.model.AccessProblem.NAME_TAKEN -> Res.string.access_error_name_taken
            com.evoapps.evoshift.domain.model.AccessProblem.TOO_MANY_ROLES -> Res.string.access_error_too_many_roles
            com.evoapps.evoshift.domain.model.AccessProblem.ROLE_IN_USE -> Res.string.access_error_role_in_use
            com.evoapps.evoshift.domain.model.AccessProblem.NOT_FOUND -> Res.string.access_error_not_found
            com.evoapps.evoshift.domain.model.AccessProblem.MALFORMED,
            com.evoapps.evoshift.domain.model.AccessProblem.BUILT_IN -> Res.string.roles_name_error
        }
    )
    // SH-269: why the server refused a group settings change.
    is com.evoapps.evoshift.domain.model.GroupSettingsRefusedException -> UiText.Resource(
        when (reason) {
            com.evoapps.evoshift.domain.model.GroupSettingsRefusedException.Reason.PLAN_ENDED -> Res.string.group_settings_error_plan_ended
            com.evoapps.evoshift.domain.model.GroupSettingsRefusedException.Reason.FOOTER_NEEDS_PAID_PLAN -> Res.string.group_settings_error_footer
            com.evoapps.evoshift.domain.model.GroupSettingsRefusedException.Reason.NOT_FINANCES -> Res.string.group_settings_error_not_finances
            com.evoapps.evoshift.domain.model.GroupSettingsRefusedException.Reason.NOT_ALLOWED -> Res.string.error_permission_denied
            com.evoapps.evoshift.domain.model.GroupSettingsRefusedException.Reason.NO_GROUP -> Res.string.group_settings_error_no_group
            com.evoapps.evoshift.domain.model.GroupSettingsRefusedException.Reason.INVALID_VALUE -> Res.string.group_settings_error_invalid
        }
    )
    is com.evoapps.evoshift.domain.model.NotAOneOffCostException -> UiText.Resource(Res.string.error_not_a_one_off_cost)
    is com.evoapps.evoshift.domain.model.InvalidAdjustmentException -> UiText.Resource(
        when (problem) {
            com.evoapps.evoshift.domain.model.InvalidAdjustmentException.Problem.DESCRIPTION_MISSING -> Res.string.field_required
            com.evoapps.evoshift.domain.model.InvalidAdjustmentException.Problem.AMOUNT_NOT_POSITIVE -> Res.string.error_one_off_amount
            com.evoapps.evoshift.domain.model.InvalidAdjustmentException.Problem.DATE_OUTSIDE_MONTH -> Res.string.error_one_off_date
        }
    )
    is com.evoapps.evoshift.domain.model.MonthLockedException -> UiText.Resource(Res.string.adjustment_month_locked)
    // SH-118: a post or a shift note that cannot be saved.
    // SH-125: a job post that cannot be saved names the field.
    is com.evoapps.evoshift.domain.model.InvalidJobPostException -> UiText.Resource(jobPostProblemText(problem))
    is com.evoapps.evoshift.domain.model.InvalidInterviewException -> UiText.Resource(interviewProblemText(problem))
    is com.evoapps.evoshift.domain.usecase.team.InvalidMessageException -> when (problem) {
        com.evoapps.evoshift.domain.usecase.team.InvalidMessageException.Problem.EMPTY -> UiText.Resource(Res.string.field_required)
        com.evoapps.evoshift.domain.usecase.team.InvalidMessageException.Problem.TOO_LONG ->
            UiText.Resource(Res.string.announcement_too_long, maxLength)
        com.evoapps.evoshift.domain.usecase.team.InvalidMessageException.Problem.NOBODY_ON_SHIFT -> UiText.Resource(Res.string.shift_note_nobody)
    }
    // SH-121: the first thing to fix in a checklist template (or a tick without its note).
    is com.evoapps.evoshift.domain.model.InvalidChecklistException -> problems.sortedBy { it.ordinal }.firstOrNull()?.toUiText() ?: generic()
    is com.evoapps.evoshift.domain.model.RosterMailRefusedException -> UiText.Resource(
        when (reason) {
            com.evoapps.evoshift.domain.model.RosterMailRefusal.TOO_SOON -> Res.string.email_roster_too_soon
            com.evoapps.evoshift.domain.model.RosterMailRefusal.NOT_PUBLISHED -> Res.string.email_roster_not_published
            com.evoapps.evoshift.domain.model.RosterMailRefusal.PLAN_ENDED -> Res.string.email_roster_plan_ended
            com.evoapps.evoshift.domain.model.RosterMailRefusal.NOT_SET_UP -> Res.string.email_roster_not_set_up
        }
    )
    is ClockException -> clockText()
    is com.evoapps.evoshift.domain.model.ClockReviewException -> when (reason) {
        com.evoapps.evoshift.domain.model.ClockReviewException.Reason.NOTHING_TO_DECIDE -> UiText.Resource(Res.string.clock_review_error_decided)
        com.evoapps.evoshift.domain.model.ClockReviewException.Reason.NOT_CLOCKED_IN -> UiText.Resource(Res.string.clock_review_error_not_clocked)
        com.evoapps.evoshift.domain.model.ClockReviewException.Reason.NO_PLAN -> UiText.Resource(Res.string.clock_review_error_no_plan)
        com.evoapps.evoshift.domain.model.ClockReviewException.Reason.BAD_TIMES -> UiText.Resource(Res.string.clock_review_edit_invalid)
        com.evoapps.evoshift.domain.model.ClockReviewException.Reason.DAY_CLOSED -> UiText.Resource(Res.string.daily_records_locked)
        com.evoapps.evoshift.domain.model.ClockReviewException.Reason.PLAN_ENDED -> UiText.Resource(Res.string.clock_review_error_plan_ended)
        com.evoapps.evoshift.domain.model.ClockReviewException.Reason.NOT_WORKED -> UiText.Resource(Res.string.work_hours_error_not_worked)
    }
    // SH-257: the person's own hours refused by reportWorkHours.
    is com.evoapps.evoshift.domain.model.WorkHoursReportException -> UiText.Resource(
        when (reason) {
            com.evoapps.evoshift.domain.model.WorkHoursReportException.Reason.NOT_YOURS -> Res.string.work_hours_error_not_yours
            com.evoapps.evoshift.domain.model.WorkHoursReportException.Reason.PLAN_ENDED -> Res.string.clock_review_error_plan_ended
            com.evoapps.evoshift.domain.model.WorkHoursReportException.Reason.SELF_ENTRY_OFF -> Res.string.work_hours_error_self_entry_off
            com.evoapps.evoshift.domain.model.WorkHoursReportException.Reason.OUTSIDE_WINDOW -> Res.string.work_hours_error_outside_window
            com.evoapps.evoshift.domain.model.WorkHoursReportException.Reason.BAD_TIMES -> Res.string.clock_review_edit_invalid
            com.evoapps.evoshift.domain.model.WorkHoursReportException.Reason.IN_FUTURE -> Res.string.work_hours_error_in_future
            com.evoapps.evoshift.domain.model.WorkHoursReportException.Reason.ALREADY_CONFIRMED -> Res.string.work_hours_error_already_confirmed
            com.evoapps.evoshift.domain.model.WorkHoursReportException.Reason.DAY_CLOSED -> Res.string.daily_records_locked
        }
    )
    is com.evoapps.evoshift.domain.model.BreakException -> breakProblemText(problem)
    is ClaimRefusedException -> UiText.Resource(
        when (reason) {
            ClaimRefusal.NOT_AVAILABLE -> Res.string.claim_refused_not_available
            ClaimRefusal.OWN_SHIFT -> Res.string.claim_refused_own
            ClaimRefusal.OVERLAP -> Res.string.claim_refused_overlap
        }
    )
    is CreateRosterUseCase.RosterAlreadyExistsException -> UiText.Resource(Res.string.error_roster_exists)
    is com.evoapps.evoshift.domain.usecase.availability.AvailabilityMonthPassedException -> UiText.Resource(Res.string.error_availability_month_passed)
    is com.evoapps.evoshift.domain.usecase.availability.AvailabilityMonthClosedException -> UiText.Resource(Res.string.error_availability_month_closed)
    is BillingException -> billingText()
    is FirebaseNetworkException -> UiText.Resource(Res.string.error_offline)
    is FirebaseTooManyRequestsException -> UiText.Resource(Res.string.error_too_many_requests)
    is FirebaseAuthWeakPasswordException -> UiText.Resource(Res.string.error_weak_password)
    is FirebaseAuthInvalidCredentialsException, is FirebaseAuthInvalidUserException ->
        UiText.Resource(Res.string.error_invalid_credentials)
    is FirebaseAuthUserCollisionException -> UiText.Resource(Res.string.error_email_in_use)
    is FirebaseAuthRecentLoginRequiredException -> UiText.Resource(Res.string.error_recent_login)
    is FirebaseAuthEmailException -> UiText.Resource(Res.string.error_invalid_email)
    // The web SDK leaves some codes unmapped (the emulator still uses wrong-password / user-not-found).
    is FirebaseAuthException -> authCodeText() ?: generic()
    is FirebaseFirestoreException -> when (code) {
        FirestoreExceptionCode.PERMISSION_DENIED -> UiText.Resource(Res.string.error_permission_denied)
        FirestoreExceptionCode.UNAUTHENTICATED -> UiText.Resource(Res.string.error_session_expired)
        FirestoreExceptionCode.UNAVAILABLE, FirestoreExceptionCode.DEADLINE_EXCEEDED -> UiText.Resource(Res.string.error_offline)
        FirestoreExceptionCode.NOT_FOUND -> UiText.Resource(Res.string.error_not_found)
        else -> generic()
    }
    // SH-122: a document the app does not send (checked before the upload).
    is com.evoapps.evoshift.domain.model.InvalidDocumentException -> when (problem) {
        com.evoapps.evoshift.domain.model.DocumentProblem.EMPTY -> UiText.Resource(Res.string.documents_file_empty)
        com.evoapps.evoshift.domain.model.DocumentProblem.TOO_LARGE ->
            UiText.Resource(Res.string.documents_file_too_large, com.evoapps.evoshift.domain.model.DocumentFiles.MAX_BYTES / (1024 * 1024))
        com.evoapps.evoshift.domain.model.DocumentProblem.UNSUPPORTED_TYPE -> UiText.Resource(Res.string.documents_file_unsupported)
        com.evoapps.evoshift.domain.model.DocumentProblem.MISSING_TITLE -> UiText.Resource(Res.string.field_required)
    }
    // SH-126: training. The server's refusals with a reason, a course the editor cannot save.
    is com.evoapps.evoshift.domain.model.CourseActionException -> courseFailureText(failure)
    is com.evoapps.evoshift.domain.model.InvalidCourseException ->
        problems.sortedBy { it.ordinal }.firstOrNull()?.let { courseProblemText(it) } ?: generic()
    is com.evoapps.evoshift.domain.usecase.courses.QuizNotFinishedException -> UiText.Resource(Res.string.course_answer_all)
    // SH-94: profile photo uploads (Firebase Storage REST); 403 = storage.rules refused the file.
    is com.evoapps.evoshift.domain.usecase.user.ProfilePhotoTooLargeException -> UiText.Resource(Res.string.profile_photo_too_large)
    is com.evoapps.evoshift.data.remote.FirebaseStorageException -> when (status) {
        401 -> UiText.Resource(Res.string.error_session_expired)
        403 -> UiText.Resource(Res.string.profile_photo_refused)
        else -> UiText.Resource(Res.string.profile_photo_upload_failed).also { AppTelemetry.recordNonFatal(this) }
    }
    is CloudFunctionsException -> when (code) {
        // SH-131: a split across a workplace that is not the caller's own.
        "permission-denied" -> if ((details as? kotlinx.serialization.json.JsonObject)?.get("reason")?.toString()?.trim('"') == "WORKPLACE_NOT_OWNED") {
            UiText.Resource(Res.string.shared_cost_error_not_owned)
        } else UiText.Resource(Res.string.error_permission_denied)
        "unauthenticated" -> UiText.Resource(Res.string.error_session_expired)
        "unavailable", "deadline-exceeded" -> UiText.Resource(Res.string.error_offline)
        "not-found" -> UiText.Resource(Res.string.error_not_found)
        // The functions write their own user-facing messages for these.
        "invalid-argument", "failed-precondition", "already-exists" -> message?.let(UiText::Raw) ?: generic()
        // "internal" etc.: the text is an HTTP status or a stack, not something to show.
        else -> UiText.Resource(Res.string.error_generic).also { AppTelemetry.recordNonFatal(this) }
    }
    else -> generic()
}

/** Store failures (SH-38); CANCELLED is filtered out by the callers (closing the sheet is fine). */
private fun BillingException.billingText(): UiText = UiText.Resource(
    when (reason) {
        BillingException.Reason.NOT_CONFIGURED -> Res.string.error_billing_not_configured
        BillingException.Reason.OFFER_UNAVAILABLE -> Res.string.error_billing_offer_unavailable
        BillingException.Reason.PAYMENT_PENDING -> Res.string.error_billing_pending
        BillingException.Reason.NOT_ALLOWED -> Res.string.error_billing_not_allowed
        BillingException.Reason.NETWORK -> Res.string.error_offline
        BillingException.Reason.CHANGE_IN_PORTAL -> Res.string.paywall_change_in_portal
        BillingException.Reason.CANCELLED, BillingException.Reason.STORE_ERROR -> Res.string.error_billing_store
    }
)

private fun Throwable.authCodeText(): UiText? {
    val text = message.orEmpty()
    return when {
        listOf("wrong-password", "user-not-found", "invalid-credential", "invalid-login-credentials", "INVALID_PASSWORD", "EMAIL_NOT_FOUND")
            .any { it in text } -> UiText.Resource(Res.string.error_invalid_credentials)
        "too-many-requests" in text || "TOO_MANY_ATTEMPTS" in text -> UiText.Resource(Res.string.error_too_many_requests)
        "invalid-email" in text || "INVALID_EMAIL" in text || "missing-email" in text -> UiText.Resource(Res.string.error_invalid_email)
        "missing-password" in text -> UiText.Resource(Res.string.error_invalid_credentials)
        "network-request-failed" in text -> UiText.Resource(Res.string.error_offline)
        // A provider not enabled in Firebase Auth yet (Apple until the owner's setup, SH-92).
        "operation-not-allowed" in text || "OPERATION_NOT_ALLOWED" in text || "sign-in provider is disabled" in text ->
            UiText.Resource(Res.string.error_sign_in_method_disabled)
        else -> null
    }
}

private fun Throwable.generic(): UiText =
    when {
        // The web SDK and wrapped failures carry the server's refusal only in the text. The app
        // hides what a role may not use (Gate), so this should not happen in normal use.
        isPermissionDenied() -> UiText.Resource(Res.string.error_permission_denied)
        else -> {
            // An unexpected failure: a non-fatal crash report, if the person allowed them (SH-86).
            AppTelemetry.recordNonFatal(this)
            message?.takeIf { it.isNotBlank() }
                ?.let { UiText.Resource(Res.string.error_generic_detail, it) }
                ?: UiText.Resource(Res.string.error_generic)
        }
    }

private fun Throwable.isPermissionDenied(): Boolean {
    val text = generateSequence(this) { it.cause }.take(5).mapNotNull { it.message }.joinToString(" ")
    return listOf("PERMISSION_DENIED", "permission-denied", "Missing or insufficient permissions").any { it in text }
}

private fun ClockException.clockText(): UiText = when (reason) {
    ClockException.Reason.TOO_EARLY -> UiText.Resource(Res.string.clock_too_early)
    ClockException.Reason.NOT_YOUR_SHIFT -> UiText.Resource(Res.string.clock_not_yours)
    ClockException.Reason.ALREADY_CLOCKED_IN -> UiText.Resource(Res.string.clock_already_in)
    ClockException.Reason.NOT_CLOCKED_IN -> UiText.Resource(Res.string.clock_not_in)
    // SH-116.
    ClockException.Reason.ALREADY_ON_BREAK -> UiText.Resource(Res.string.clock_already_on_break)
    ClockException.Reason.NOT_ON_BREAK -> UiText.Resource(Res.string.clock_not_on_break)
    ClockException.Reason.TOO_MANY_BREAKS -> UiText.Resource(Res.string.clock_too_many_breaks)
    ClockException.Reason.NO_SHIFT_NOW -> UiText.Resource(Res.string.clock_no_shift_now)
    ClockException.Reason.ALREADY_DONE -> UiText.Resource(Res.string.clock_already_done)
    ClockException.Reason.UNDO_TOO_LATE -> UiText.Resource(Res.string.clock_undo_too_late)
    // SH-106 (Block mode).
    ClockException.Reason.OUTSIDE_AREA -> UiText.Resource(
        Res.string.clock_outside_area,
        distanceMeters ?: 0,
        radiusMeters ?: GeofenceSettings.DEFAULT_RADIUS_METERS
    )
    ClockException.Reason.LOCATION_REQUIRED -> UiText.Resource(
        when (locationUnavailable) {
            LocationUnavailable.DENIED -> Res.string.clock_location_denied
            LocationUnavailable.UNSUPPORTED -> Res.string.clock_location_unsupported
            LocationUnavailable.NO_FIX, null -> Res.string.clock_location_no_fix
        }
    )
}

/** SH-116: why a manager's break correction cannot be saved. */
fun breakProblemText(problem: com.evoapps.evoshift.domain.model.BreakProblem): UiText = when (problem) {
    com.evoapps.evoshift.domain.model.BreakProblem.UNREADABLE -> UiText.Resource(Res.string.break_problem_unreadable)
    com.evoapps.evoshift.domain.model.BreakProblem.ENDS_BEFORE_START -> UiText.Resource(Res.string.break_problem_ends_before_start)
    com.evoapps.evoshift.domain.model.BreakProblem.OUTSIDE_SHIFT -> UiText.Resource(Res.string.break_problem_outside_shift)
    com.evoapps.evoshift.domain.model.BreakProblem.OVERLAP -> UiText.Resource(Res.string.break_problem_overlap)
    com.evoapps.evoshift.domain.model.BreakProblem.OPEN_AFTER_CLOCK_OUT -> UiText.Resource(Res.string.break_problem_open)
    com.evoapps.evoshift.domain.model.BreakProblem.TOO_MANY -> UiText.Resource(Res.string.break_problem_too_many, com.evoapps.evoshift.domain.model.BreakRules.MAX_BREAKS)
}

/** SH-106: the note after a clock-in or clock-out the manager will see flagged (Warn mode); null when nothing to say. */
fun ClockOutcome.toNote(): UiText? = when {
    // SH-134: a clock-in without one's own shift, pending a manager.
    unplanned?.kind == com.evoapps.evoshift.domain.model.UnplannedKind.COVER ->
        UiText.Resource(Res.string.clock_unplanned_cover_done, unplanned?.coveredName ?: "?")
    unplanned != null -> UiText.Resource(Res.string.clock_unplanned_extra_done)
    check == LocationCheck.OUTSIDE -> UiText.Resource(Res.string.clock_flag_outside, distanceMeters ?: 0)
    check == LocationCheck.UNVERIFIED -> UiText.Resource(Res.string.clock_flag_unverified)
    else -> null
}

/** SH-121: what to fix in a checklist template, or a tick without the note it needs. */
fun com.evoapps.evoshift.domain.model.ChecklistProblem.toUiText(): UiText = when (this) {
    com.evoapps.evoshift.domain.model.ChecklistProblem.NO_NAME -> UiText.Resource(Res.string.checklist_problem_no_name)
    com.evoapps.evoshift.domain.model.ChecklistProblem.NO_ITEMS -> UiText.Resource(Res.string.checklist_problem_no_items)
    com.evoapps.evoshift.domain.model.ChecklistProblem.EMPTY_ITEM -> UiText.Resource(Res.string.checklist_problem_empty_item)
    com.evoapps.evoshift.domain.model.ChecklistProblem.TOO_MANY_ITEMS ->
        UiText.Resource(Res.string.checklist_problem_too_many, com.evoapps.evoshift.domain.model.Checklists.MAX_ITEMS)
    com.evoapps.evoshift.domain.model.ChecklistProblem.TOO_LONG -> UiText.Resource(Res.string.checklist_problem_too_long)
    com.evoapps.evoshift.domain.model.ChecklistProblem.NOT_ATTACHED -> UiText.Resource(Res.string.checklist_problem_not_attached)
    com.evoapps.evoshift.domain.model.ChecklistProblem.NOTE_REQUIRED -> UiText.Resource(Res.string.checklist_note_required)
}
/**
 * SH-122: a document upload, download or removal failure. Storage refusals and transfer errors get
 * the documents' own texts (the generic Storage texts speak of profile photos); the rest as
 * [toUiText].
 */
fun Throwable.toDocumentUiText(): UiText = when (this) {
    is com.evoapps.evoshift.data.remote.FirebaseStorageException -> when (status) {
        401 -> UiText.Resource(Res.string.error_session_expired)
        403 -> UiText.Resource(Res.string.documents_refused)
        else -> UiText.Resource(Res.string.documents_transfer_failed).also { AppTelemetry.recordNonFatal(this) }
    }
    else -> toUiText()
}

/** SH-126: why the server refused a training action. */
fun courseFailureText(failure: com.evoapps.evoshift.domain.model.CourseFailure): UiText = UiText.Resource(
    when (failure) {
        com.evoapps.evoshift.domain.model.CourseFailure.COURSE_CHANGED -> Res.string.course_failure_changed
        com.evoapps.evoshift.domain.model.CourseFailure.NO_ATTEMPTS_LEFT -> Res.string.course_failure_no_attempts
        com.evoapps.evoshift.domain.model.CourseFailure.CONFIRMATION_MISSING -> Res.string.course_failure_confirmation
        com.evoapps.evoshift.domain.model.CourseFailure.SELF_STUDY_NOT_ALLOWED -> Res.string.course_failure_self_study
        com.evoapps.evoshift.domain.model.CourseFailure.TEST_NOT_PASSED -> Res.string.course_failure_test_not_passed
        com.evoapps.evoshift.domain.model.CourseFailure.NOTHING_TO_CONFIRM -> Res.string.course_failure_nothing_to_confirm
        com.evoapps.evoshift.domain.model.CourseFailure.NOT_READY -> Res.string.course_failure_not_ready
        com.evoapps.evoshift.domain.model.CourseFailure.PLAN_ENDED -> Res.string.course_failure_plan_ended
        com.evoapps.evoshift.domain.model.CourseFailure.OWNER_NOT_TRAINED -> Res.string.course_failure_owner
    }
)

/** SH-126: what keeps a course from being saved or published. */
fun courseProblemText(problem: com.evoapps.evoshift.domain.model.CourseProblem): UiText = when (problem) {
    com.evoapps.evoshift.domain.model.CourseProblem.MISSING_TITLE -> UiText.Resource(Res.string.course_problem_title)
    com.evoapps.evoshift.domain.model.CourseProblem.TITLE_TOO_LONG -> UiText.Resource(Res.string.course_problem_too_long)
    com.evoapps.evoshift.domain.model.CourseProblem.NO_PAGES -> UiText.Resource(Res.string.course_problem_no_pages)
    com.evoapps.evoshift.domain.model.CourseProblem.TOO_MANY_PAGES ->
        UiText.Resource(Res.string.course_problem_too_many_pages, com.evoapps.evoshift.domain.model.CourseRules.MAX_PAGES)
    com.evoapps.evoshift.domain.model.CourseProblem.PAGE_TOO_LONG -> UiText.Resource(Res.string.course_problem_too_long)
    com.evoapps.evoshift.domain.model.CourseProblem.BAD_VIDEO_LINK -> UiText.Resource(Res.string.course_problem_video_link)
    com.evoapps.evoshift.domain.model.CourseProblem.MISSING_IMAGE -> UiText.Resource(Res.string.course_problem_image)
    com.evoapps.evoshift.domain.model.CourseProblem.BAD_PRESENTATION -> UiText.Resource(Res.string.course_problem_presentation)
    com.evoapps.evoshift.domain.model.CourseProblem.COURSE_TOO_LARGE -> UiText.Resource(Res.string.course_problem_course_too_large)
    com.evoapps.evoshift.domain.model.CourseProblem.TOO_MANY_QUESTIONS ->
        UiText.Resource(Res.string.course_problem_too_many_questions, com.evoapps.evoshift.domain.model.CourseRules.MAX_QUESTIONS)
    com.evoapps.evoshift.domain.model.CourseProblem.QUESTION_WITHOUT_TEXT -> UiText.Resource(Res.string.course_problem_question_text)
    com.evoapps.evoshift.domain.model.CourseProblem.BAD_OPTIONS -> UiText.Resource(Res.string.course_problem_options)
    com.evoapps.evoshift.domain.model.CourseProblem.NO_RIGHT_ANSWER -> UiText.Resource(Res.string.course_problem_right_answer)
    com.evoapps.evoshift.domain.model.CourseProblem.BAD_PASS_PERCENT -> UiText.Resource(Res.string.course_problem_pass_percent)
    com.evoapps.evoshift.domain.model.CourseProblem.BAD_DUE_DAYS ->
        UiText.Resource(Res.string.course_problem_due_days, com.evoapps.evoshift.domain.model.CourseRules.MAX_DUE_DAYS)
    com.evoapps.evoshift.domain.model.CourseProblem.OHS_NEEDS_QUIZ -> UiText.Resource(Res.string.course_problem_ohs_quiz)
    com.evoapps.evoshift.domain.model.CourseProblem.OHS_NEEDS_INSTRUCTOR -> UiText.Resource(Res.string.course_problem_ohs_instructor)
    com.evoapps.evoshift.domain.model.CourseProblem.OHS_TOO_SHORT -> UiText.Resource(Res.string.course_problem_ohs_hours)
}

/** SH-125: what to fix in a job post. */
fun jobPostProblemText(problem: com.evoapps.evoshift.domain.model.InvalidJobPostException.Problem) = when (problem) {
    com.evoapps.evoshift.domain.model.InvalidJobPostException.Problem.TITLE_REQUIRED -> Res.string.job_error_title
    com.evoapps.evoshift.domain.model.InvalidJobPostException.Problem.PAY_REQUIRED -> Res.string.job_error_pay
    com.evoapps.evoshift.domain.model.InvalidJobPostException.Problem.PAY_RANGE -> Res.string.job_error_pay_range
    com.evoapps.evoshift.domain.model.InvalidJobPostException.Problem.EMPLOYER_REQUIRED -> Res.string.job_error_employer
    com.evoapps.evoshift.domain.model.InvalidJobPostException.Problem.CONTACT_REQUIRED -> Res.string.job_error_contact
    com.evoapps.evoshift.domain.model.InvalidJobPostException.Problem.DATE_INVALID -> Res.string.date_format_invalid
    com.evoapps.evoshift.domain.model.InvalidJobPostException.Problem.TOO_LONG -> Res.string.job_error_too_long
    com.evoapps.evoshift.domain.model.InvalidJobPostException.Problem.CV_TYPES_REQUIRED -> Res.string.job_error_cv_types
}

/** SH-210: what to fix in the interview dialog. */
fun interviewProblemText(problem: com.evoapps.evoshift.domain.model.InvalidInterviewException.Problem) = when (problem) {
    com.evoapps.evoshift.domain.model.InvalidInterviewException.Problem.TIME_INVALID -> Res.string.interview_error_time
    com.evoapps.evoshift.domain.model.InvalidInterviewException.Problem.LENGTH_INVALID -> Res.string.interview_error_length
    com.evoapps.evoshift.domain.model.InvalidInterviewException.Problem.PLACE_REQUIRED -> Res.string.interview_error_place
    com.evoapps.evoshift.domain.model.InvalidInterviewException.Problem.LINK_INVALID -> Res.string.interview_error_link
    com.evoapps.evoshift.domain.model.InvalidInterviewException.Problem.TOO_LONG -> Res.string.job_error_too_long
    com.evoapps.evoshift.domain.model.InvalidInterviewException.Problem.PARTICIPANTS_TOO_MANY -> Res.string.interview_error_participants
}

/** SH-236: why a shift could not be split (or the split undone). */
fun com.evoapps.evoshift.domain.model.SplitProblem.textRes(): org.jetbrains.compose.resources.StringResource = when (this) {
    com.evoapps.evoshift.domain.model.SplitProblem.NOBODY_ON_SHIFT -> Res.string.split_problem_nobody
    com.evoapps.evoshift.domain.model.SplitProblem.ALREADY_SPLIT -> Res.string.split_problem_already
    com.evoapps.evoshift.domain.model.SplitProblem.HANDOVER_OUTSIDE -> Res.string.split_problem_outside
    com.evoapps.evoshift.domain.model.SplitProblem.SAME_PERSON -> Res.string.split_problem_same_person
    com.evoapps.evoshift.domain.model.SplitProblem.DAY_CLOSED -> Res.string.split_problem_closed
    com.evoapps.evoshift.domain.model.SplitProblem.OTHER_PART_MISSING -> Res.string.split_problem_missing
}
